import { FormikProps } from 'formik';
import Image from 'next/image';
import { useFormContext } from '../../../../../contexts/FormContext';
import { PersonaNewsletterInput } from '../../../../../types/FormTypes';

import styles from './AdvancedInputs.module.css';
import { KeywordInputs } from './KeywordInputs';
import { LengthInput } from './LengthInput';
import {
  EmojiHashtagIntents,
  LengthIntents,
} from '../../../../../types/FormOptions.type';
import { HashtagSelectionInput, EmojiSelectionInput } from './EmojiHastagInput';

type AdvancedPersonaInputProps<T> = {
  formikProps: FormikProps<T>;
  disabled: boolean;
};

export function AdvancedPersonaNewsletterInputs<
  T extends PersonaNewsletterInput
>({ formikProps, disabled }: AdvancedPersonaInputProps<T>) {
  const { formType, showAdvancedInputs, setShowAdvancedInputs } =
    useFormContext();

  return (
    <div className={styles['container']}>
      <button
        aria-label="advanced-inputs"
        onClick={() => setShowAdvancedInputs(!showAdvancedInputs)}
        className={styles['header-container']}
      >
        <h2>Advanced Input Settings</h2>
        <div className={styles['toggle-icon']}>
          <Image
            src="/icons/ChevronDownBlack.svg"
            alt={showAdvancedInputs ? 'Close' : 'Open'}
            layout="fixed"
            objectFit="contain"
            height={24}
            width={24}
          />
        </div>
      </button>
      {showAdvancedInputs && (
        <div className={styles['inputs-container']}>
          <KeywordInputs formikProps={formikProps} disabled={disabled} />
          <LengthInput
            formikProps={formikProps}
            disabled={disabled}
            defaultOptions={Object.keys(LengthIntents)}
          />
          {/* <HashtagSelectionInput
            formikProps={formikProps}
            disabled={disabled}
            defaultOptions={Object.keys(EmojiHashtagIntents)}
          /> */}
          <EmojiSelectionInput
            formikProps={formikProps}
            disabled={disabled}
            defaultOptions={Object.keys(EmojiHashtagIntents)}
          />
        </div>
      )}
    </div>
  );
}
